/** Origem funcional que abriu o assistente compartilhado de importação da NF-e. */
export enum OrigemImportacaoXmlNFeEntradaEnum {
  CentralNotas = 1,
  KanbanCompras = 2,
}
